import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import * as Utils from "./utils/Utils";
import * as mod_i18n from "./utils/i18n";
const Footer_footerDefault = styled("footer")(({ theme }) => ({}));
const Footer_footerFixed = styled(Footer_footerDefault)(({ theme }) => ({
    height: "100%",
    minHeight: "3rem", //  "var(--footer-height)"
}));
const Grid_footerContainer = styled(Grid)(({ theme }) => ({
    backgroundColor: "#001a37", //  "var(--clr-primary)"
    height: "3rem", //  "var(--footer-height)"
    padding: "0 1rem",
    width: "calc(100vw - (100vw - 100%)) !important",
    margin: "0 !important",
}));
const Grid_footerContainerFixed = styled(Grid_footerContainer)(({ theme }) => ({
    position: "fixed",
    bottom: 0,
}));
const Grid_copyrightContainer = styled(Grid)(({ theme }) => ({}));
const Typography_copyright = styled(Typography)(({ theme }) => ({
    color: "#fff", // "var(--clr-white)"
    fontFamily: "BrownStd-Regular", // "var(--default-font-family)"
    fontSize: "1.4rem",
}));
const Grid_socialnavContainer = styled(Grid)(({ theme }) => ({}));
const Img_socialIcon = styled("img")(({ theme }) => ({
    cursor: "pointer",
    height: "1.4rem",
    width: "1.4rem",
    "&:hover": {
        transform: "translateY(-0.3rem)",
    },
    filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(304deg ) brightness(106%) contrast(101%)",
}));
const Grid_imprintContainer = styled(Grid)(({ theme }) => ({
    "& a": {
        textDecoration: "none",
        fontFamily: "BrownStd-Regular", // "var(--default-font-family)"
        fontSize: "1.4rem",
        color: "#fff", // "var(--clr-white)"
        "&:hover,:focus": {
            textDecoration: "underline",
        },
    },
}));
const Footer = (props) => {
    const [socialMedia, setSocialMedia] = useState([]);
    const [menuFooter, setMenuFooter] = useState([]);
    let pathToStatic = props.appModel.pathToStatic;
    let pathToApi = props.appModel.pathToAppFrameApi;
    let lang = props.appModel.language;
    let defaultLang = props.appModel.config.defaultLanguage;
    useEffect(() => {
        Utils.fetchAsync(pathToApi + "menu/social-media", null, (value) => {
            const newValue = value && value["children"];
            if (newValue == null) {
                setSocialMedia([]);
            }
            else {
                setSocialMedia(newValue);
            }
        });
        Utils.fetchAsync(pathToApi + "menu/footer", null, (value) => {
            const newValue = value && value["children"];
            if (newValue == null) {
                setMenuFooter([]);
            }
            else {
                setMenuFooter(newValue);
            }
        });
    }, []);
    const getSocialMediaIconPath = (title) => {
        const name = String(title).toLowerCase().replace(/[\W]/g, "");
        return pathToStatic + "images/social_media/icon_" + name + ".svg";
    };
    const getMenuTitle = (menuEntry) => {
        return mod_i18n.getMenuTitle(menuEntry, lang, defaultLang);
    };
    const getMenuUrl = (menuEntry) => {
        return mod_i18n.getMenuUrl(menuEntry, lang, defaultLang);
    };
    const renderSocialEntry = (item, i) => {
        return (React.createElement(Grid, { item: true, id: "socialentry__" + String(i), key: "socialentry_" + String(i), xs: 2, sm: 1 },
            React.createElement("a", { href: getMenuUrl(item), key: "a_" + String(i) },
                React.createElement(Img_socialIcon, { src: getSocialMediaIconPath(getMenuTitle(item)), key: "img_" + String(i), alt: getMenuTitle(item) }))));
    };
    const footerContainerContent = (React.createElement(React.Fragment, null,
        React.createElement(Grid_copyrightContainer, { item: true, key: "zebDshFooter_copyright", xs: 2, sm: 3 },
            React.createElement(Typography_copyright, null, "©" + new Date().getFullYear() + " zeb")),
        React.createElement(Grid_socialnavContainer, { item: true, key: "zebDshFooter_social", container: true, justifyContent: "center", alignItems: "center", xs: 5, sm: 6, wrap: "nowrap" }, socialMedia.map((item, i) => renderSocialEntry(item, i))),
        React.createElement(Grid_imprintContainer, { item: true, key: "zebDshFooter_imprint", container: true, spacing: 1, wrap: "nowrap", justifyContent: "flex-end", xs: 3, sm: 2, md: 3 }, menuFooter.map((menuItem, i) => (React.createElement(Grid, { key: "zebDshFooter_imprint_" + String(i), item: true, xs: 12, sm: 12, md: 6, lg: 4 },
            React.createElement("a", { href: getMenuUrl(menuItem), key: i },
                React.createElement(Typography_copyright, null, getMenuTitle(menuItem)))))))));
    if (props.fixedToBottom) {
        return (React.createElement(Footer_footerFixed, { id: "zebDshAppFrameFooter" },
            React.createElement(Grid_footerContainerFixed, { id: "zebDshFooter", key: "zebDshFooter", container: true, alignItems: "center", justifyContent: "space-between" }, footerContainerContent)));
    }
    else {
        return (React.createElement(Footer_footerDefault, { id: "zebDshAppFrameFooter" },
            React.createElement(Grid_footerContainer, { id: "zebDshFooter", key: "zebDshFooter", container: true, alignItems: "center", justifyContent: "space-between" }, footerContainerContent)));
    }
};
export default Footer;
